import { render, staticRenderFns } from "./power.vue?vue&type=template&id=21affdbe&scoped=true&"
import script from "./power.vue?vue&type=script&lang=js&"
export * from "./power.vue?vue&type=script&lang=js&"
import style0 from "./power.vue?vue&type=style&index=0&id=21affdbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21affdbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21affdbe')) {
      api.createRecord('21affdbe', component.options)
    } else {
      api.reload('21affdbe', component.options)
    }
    module.hot.accept("./power.vue?vue&type=template&id=21affdbe&scoped=true&", function () {
      api.rerender('21affdbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/install/power.vue"
export default component.exports